(function($) {

	'use strict';

	var initOpenAccordionTabs = function() {

        if($('.accordion').length > 0) {       
            openAccordionTabs();
        }

    }

    var openAccordionTabs = function() {

        var $accordionItem = $('.accordion__item__title');

        $accordionItem.on("click", function() {
            var $accordionItem = $(this).closest('.accordion__item');
            var $accordionItemContent = $accordionItem.find('.accordion__item__content');
            
            $accordionItem.toggleClass('active');

            if ($accordionItem.hasClass('active')) {
                $accordionItemContent.css('maxHeight', $accordionItemContent.prop('scrollHeight') + 'px');
            } else {
                $accordionItemContent.css('maxHeight', '');
            }
        });

    }

    $(document).ready(function() {
		initOpenAccordionTabs();
	});

})(jQuery);